import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import '../Style/App.css';
import { API_URL } from '../config/api';
import { useRole } from '../context/RoleContext';

const Login = () => {
  const [values, setValues] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { updateUserRole } = useRole();

  axios.defaults.withCredentials = true;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Send original email to backend - let backend handle fallback logic
      const res = await axios.post(
        `${API_URL}/auth/signin`,
        values,
        { withCredentials: true }
      );
      const token = res.data.authenticationResult?.IdToken || res.data.token;
      localStorage.setItem('idToken', token);

      // Store additional tokens if available
      if (res.data.authenticationResult?.AccessToken) {
        localStorage.setItem('accessToken', res.data.authenticationResult.AccessToken);
      }
      if (res.data.authenticationResult?.RefreshToken) {
        localStorage.setItem('refreshToken', res.data.authenticationResult.RefreshToken);
      }

      updateUserRole(token); // Update the role context with the new token
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <div className="loginPage">
      <img
        src="/GradyStar.png"
        alt="Logo"
        className="logo"
      />
      <div className="loginForm">
        {error && <div className="text-danger mb-2">{error}</div>}
        <h2 className="text-center"><strong>Login</strong></h2>
        <form onSubmit={handleSubmit}>
          <div style={{textAlign: "left", marginBottom: "5px"}}>
            <label style={{display: "block", marginBottom: "5px"}}><strong>Email:</strong></label>
            <input
              type="email"
              name="email"
              className="modern-input"
              value={values.email}
              onChange={e => setValues({ ...values, email: e.target.value })}
              required
            />
          </div>
          <div style={{textAlign: "left", marginBottom: "5px"}}>
            <label style={{display: "block", marginBottom: "5px"}}><strong>Password:</strong></label>
            <div style={{position: "relative"}}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="modern-input"
                value={values.password}
                onChange={e => setValues({ ...values, password: e.target.value })}
                required
                style={{paddingRight: "45px"}}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle-btn"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#667",
                  padding: "2px 6px",
                  width: "auto",
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          <button className="modern-btn">
            Sign In
          </button>
          <div style={{marginTop: "10px", textAlign: "center"}}>
            <p style={{fontSize: "14px", margin: "0 0 5px 0"}}>
              <Link to="/forgot-password" style={{color: "#0b3f1f"}}>Forgot Password?</Link>
            </p>
            <p style={{fontSize: "14px", margin: "0"}}>Don't have an account? <Link to="/signup" style={{color: "#0b3f1f"}}>Sign Up</Link></p>
          </div>
        </form>
      </div>
      <div className="loginDisclaimer">
        <p>Copyright © 2024 Polk County Sheriff's Office. All rights reserved.</p>
        <p>Any unauthorized use of this information is forbidden and subject to criminal prosecution.</p>
      </div>


    </div>
  );
};

export default Login;
